// sx style objects shared by the invoice wizard steps (BasicInfo, Details).

const containerSx = (theme) => ({
  maxWidth: '100%',

  '& input': {
    fontSize: theme.typography.appFontSize,
  },
});

export { containerSx };
